import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import Flux                             from './../flux/Flux';
import PjaxWrapper                      from '../utils/PjaxWrapper';
import ModalBoxContests                 from "../components/ModalBox/ModalBoxContests";
import TileGridBox                      from "../components/TileGrid/TileGridBox";
import Translations                     from '../utils/Translations';
import PropTypes                        from 'prop-types';
import withCountdown                    from '../components/HigherOrderComponents/Utility/withCountdown';
import "../../../src/VX/Asset/Less/VX/View/ContestsOverview.less";

function renderCountDown(activeContest) {
	const counterContainer = document.getElementById("contests-countdown-container");
	const endTime = new Date(activeContest.contestEndDateTimestamp * 1000);

	const ContestsCountdown = withCountdown(MyContestCountdown);

	function MyContestCountdown(props) {

		if (endTime < new Date()) {
			return null;
		}

		return (
			<div>
				{props.countdown.days === 1 ? <div><span>{props.countdown.days}</span> {Translations.get('DateDay')}</div> : <div><span>{props.countdown.days}</span> {Translations.get('Days')}</div>}
				<div><span>{props.countdown.hours}</span> {Translations.get('DateHr')}</div>
				<div><span>{props.countdown.minutes}</span> {Translations.get('DateMin')}</div>
			</div>
		);
	}

	render(<ContestsCountdown end={endTime} />, counterContainer);

	MyContestCountdown.propTypes = {
		countdown:        PropTypes.shape({
			days:           PropTypes.number,
			hours:          PropTypes.number,
			minutes:     	PropTypes.number,
		}),
	};
}

function run(lastContestContainerId, language, currentPage, maxPage, itemsPerPage, activeContest) {

	const lastContestContainer = document.getElementById(lastContestContainerId);

	if (lastContestContainer) {
		render(
			<div className="media-panel container-block -margin-bottom-lg">
				<div id="pjax-scrollto-pagination"></div>
				<h1 className="contest_overview-last_contests-heading">
					<span>
						{Translations.get('ContestsPastContestsHeadline')}
					</span>
				</h1>
				<TileGridBox type={Flux.Constants.TileGrid.CONTESTS_LAST_CONTESTS}
				             className="-no-margin"
				             payload={{language: language, page: currentPage, limit: itemsPerPage, maxPage: maxPage}}
				             tileGridId={'last-contests-overview'}
				             tilesToShow={15}
				             useInfiniteScrolling={true}
				             maxPage={maxPage}
				             gridContainerId={lastContestContainerId}
				             scrollTillPageNum={15}
							 lazyImageLoading={true}
				/>
			</div>,
			lastContestContainer
		);

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(lastContestContainer);
		});
	}

	const openModalBox = Flux.Contest.getShouldOpenNextContestsModal();

	const modalContainerId = 'modal-contests';

	if (openModalBox && Flux.Guest.isLoggedIn()) {
		const container = document.createElement('div');
		container.id    = modalContainerId;
		document.body.appendChild(container);

		render(<ModalBoxContests containerId={modalContainerId} />, container);

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(container);
		});
	}

	renderCountDown(activeContest);

}

export {run, renderCountDown};
